<template>
  <b-form-group label="نمایش بر اساس روز های هفته" label-for="weekOfDay">
    <b-form-select
      id="weekOfDay"
      v-model="selectedDay"
      :options="dayOfWeeksEnum"
    ></b-form-select>
  </b-form-group>
</template>
<script>
export default {
  emits: ["getDayOfWeek"],
  watch: {
    selectedDay: {
      handler(val) {
        this.$emit("getDayOfWeek", this.selectedDay);
      },
    },
  },
  data() {
    return {
      selectedDay: null,
      dayOfWeeksEnum: [
        {
          text: "همه",
          value: null,
        },
        {
          text: "شنبه",
          value: 6,
        },
        {
          text: "یکشنبه",
          value: 0,
        },
        {
          text: "دوشنبه",
          value: 1,
        },
        {
          text: "سه شنبه",
          value: 2,
        },
        {
          text: "چهارشنبه",
          value: 3,
        },
        {
          text: "پنجشنبه",
          value: 4,
        },
        {
          text: "جمعه",
          value: 5,
        },
      ],
    };
  },
  components: {
    BFormGroup,
    BFormSelect,
  },
};
import { BFormGroup, BFormSelect } from "bootstrap-vue";
</script>
